<template>
  <v-container fluid>
    <!-- Search bar -->
    <v-row align="center">
      <v-col cols="6" class="text-left mb-2">
        <v-text-field v-model="search" label="Recherchez une entreprise" single-line hide-details></v-text-field>
      </v-col>
    </v-row>

    <!-- Data table for displaying exclusions -->
    <v-data-table locale="fr" :headers="headers" :search="search" no-data-text="Aucune demande trouvée"
      :items="this.$store.getters['Auth/getDemandeQuitus']" @click:row="goto" class="elevation-1 mb-5 px-5">
      <!-- Slot for custom row rendering -->

      <template v-slot:[`item.dateDemande`]="{ item }">{{
          item.dateDemande | moment("DD MMMM YYYY")
        }}</template>

      <template v-slot:[`item.status`]="{ item }">
        <v-chip label small outlined :color="getStatusColor(item.status)"  text-color="white">{{ item.status
          }}</v-chip>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  components: { DatePicker },
  data: () => ({
    search: "",
    dialog: false,
    demandeQuitus: {
      nomCabinet: '',
      nomPersonne: '',
      emailContact: '',
      pieceJointeDemande: null,
      pieceJointeJustificative: null
    },

    headers: [
      { text: "Nom du cabinet", align: "start", sortable: false, value: "nomCabinet" },
      { text: "Personne à contacter", sortable: false, value: "nomPersonne" },
      { text: "Email du contact", sortable: false, value: "emailContact" },
      { text: "Date de demande", sortable: false, value: "dateDemande" },
      { text: "Status", sortable: false, value: "status" },
    ],
  }),
  created() {
    this.$store.dispatch("Auth/loadAllDemandeQuitus");
    this.$store.dispatch("Auth/getData");
  },
  methods: {
    ...mapActions({
      loadAllExclusions: "Auth/loadAllDemandeQuitus",
      sendDemande: "Auth/addDemandeQuitus"
    }),
    getStatusColor(status) {
      switch (status) {
        case 'Délivrée':
          return 'green--text';
        case 'Rejetée':
          return 'red--text';
        case 'En_Cours':
          return 'blue--text';
        default:
          return '';
      }
    },
    openDialog() {
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    },
    goto(value) {
      const { id } = value;
      this.$router.push({ name: "Regshow_quitus", params: { id: id } });
    },

  }
};
</script>

<style>
.vue-daterange-picker {
  width: 100% !important;
}

.mx-datepicker {
  width: 100% !important;
}

.w-62em {
  height: 62em !important;
  width: 100% !important;
}

.date-picker-wrapper {
  margin-bottom: 16px;
}

.date-picker-wrapper label {
  font-weight: bold;
}
</style>